import { css } from 'styled-components';
export default {
    cabin: {
        regular: css `
      font-family: 'Cabin', sans-serif;
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    `,
        italic: css `
      font-family: 'Cabin', sans-serif;
      font-weight: 400;
      font-style: italic;
      font-display: swap;
    `,
        bold: css `
      font-family: 'Cabin', sans-serif;
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    `,
        boldItalic: css `
      font-family: 'Cabin', sans-serif;
      font-weight: 700;
      font-style: italic;
      font-display: swap;
    `,
    },
};
